<ng-template #contentTemplate>
	<div class="m-t-30">
		<ng-container *ngIf="useOtp">
			<app-password-input-box (emitInput)="setPin($event)">
			</app-password-input-box>
			<div class="m-t-7">
				<div nz-row nzJustify="end">
					<app-otp-count-down
						(emitRetryAction)="reGeneratePasswordOTP()"
						[canShowErrorMessage]="true"
						[countdownType]="CountdownType.KAMONA"
						[errorMessage]="otpErrorMessage"
						[errorTimer]="otpSuspensionReleaseTime">
					</app-otp-count-down>
				</div>
			</div>
			<div class="m-t-24">
				<app-ussd-board
					[ussdCode]="ussdCode">
				</app-ussd-board>
			</div>
			<div class="m-t-30" nz-row nzAlign="middle" nzJustify="space-between">
				<div>
				</div>
				<div nz-row nzAlign="middle">
					<div>
						<div (click)="back.emit()" class="back-btn">
							Back
						</div>
					</div>
					<div>
						<div class="m-l-32">
							<div class="button-size-124">
								<app-kamona-custom-button (submitForm)="next()"
														[isBlock]="true"
														[isDisabled]="!disableOtpButton"
														[isSubmitting]="submittingForm" text="Next">
								</app-kamona-custom-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
		<app-liveliness class="grow flex flex-col" *ngIf="!useOtp"
			[reference]="livelinessCheckReference" [identityProvider]="identityProvider"
			(nextStepMoved)="livelinessStepCompleted($event)"
			[isSubmitting]="submittingForm"
			[isMobileView]="false"
			[noBottomPadding]="true"
			[type]="feature"
			[username]="getUsername()">
		</app-liveliness>
	</div>
</ng-template>
<ng-container *ngIf="loading else contentTemplate">
	<app-kamona-loading>
	</app-kamona-loading>
</ng-container>
